<div
  class="card card-well top-buffer animate__animated animate__fadeIn animate__faster"
  data-automation="transfer-public-component"
>
  <div class="card-header">
    <legend class="bottom-buffer mt-0 pb-2 d-flex">
      <ziro-stacked-icon
        class="icon-sm"
        [stackedIcon]="ZiroStackedIcons[ziroIcons.REASSIGN_USER]"
        parentClass="fa-stack"
      ></ziro-stacked-icon>

      <div class="d-flex flex-column" data-automation="reassign-header">
        {{
          reassignType() === ReassignTypes.PUBLIC_TO_USER
            ? ('tkey;transfer.publicToUser.title' | translate)
            : ('tkey;operations.menu.reassign.text' | translate)
        }}
      </div>
    </legend>

    <div class="pb-2">
      <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
      @if (!isLoading) {
        <div>
          @if (cannotReassign) {
            <div>
              <div class="alert alert-danger d-flex mb-0">
                <i class="me-1" [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
                <p
                  data-automation="cannot-reassign-error"
                  class="m-0"
                  [innerHTML]="'tkey;transfer.publicToUser.cannot_reassign' | escapeHtml: { displayName }"
                ></p>
              </div>
            </div>
          }
          @if (showVoicemailCard && !cannotReassign) {
            <div class="pb-2">
              <h3>
                {{ 'tkey;pages.details.transfer.keep.voicemail.prompt' | translate }}
              </h3>
              <p>
                <strong>{{ 'tkey;pages.details.transfer.keep.voicemail.subheader.note.text' | translate }}</strong>
                {{ 'tkey;pages.details.transfer.keep.voicemail.subheader.text' | translate }}
              </p>
            </div>
          }
          @if (!showVoicemailCard && !cannotReassign) {
            <div class="pb-2">
              <p
                data-automation="reassign-confirmation-text"
                [innerHTML]="
                  reassignType() === ReassignTypes.PUBLIC_TO_USER
                    ? ('tkey;transfer.publicToUser.confirmation.text' | escapeHtml: { displayName })
                    : ('tkey;transfer.userToUser.confirmation.text' | escapeHtml: { displayName })
                "
              ></p>
              @if (isVoicemailPresentOnLineOne()) {
                <p [ngClass]="isKeepVoicemail ? '' : 'fw-bold text-danger'">
                  {{
                    isKeepVoicemail
                      ? ('tkey;transfer.confirmation.voicemailKeep.text' | translate)
                      : ('tkey;transfer.confirmation.voicemailDiscard.text' | translate)
                  }}
                </p>
              }
              <p>
                <strong>{{ 'tkey;transfer.confirmation.continue.text' | translate }}</strong>
              </p>
            </div>
          }
          <div class="text-end pb-2 border-top pt-3">
            <ziro-button
              [dataAutomation]="'reassign-cancel-button'"
              [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
              [label]="'tkey;operations.menu.reassign.back'"
              [cssClass]="'me-1'"
              [isDisabled]="isSubmitting"
              (clicked)="onGoBackClicked()"
            ></ziro-button>
            @if (showVoicemailCard && !cannotReassign) {
              <ziro-button
                [dataAutomation]="'delete-voicemail-button'"
                [buttonStyle]="buttonStyles.OUTLINE_DANGER"
                [cssClass]="'me-1'"
                [label]="'tkey;pages.details.transfer.keep.voicemail.delete.button'"
                (clicked)="onVoicemailButtonClicked(false)"
              ></ziro-button>
            }
            @if (showVoicemailCard && !cannotReassign) {
              <ziro-button
                [dataAutomation]="'keep-voicemail-button'"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                [cssClass]="'me-1'"
                [label]="'tkey;pages.details.transfer.keep.voicemail.keep.button'"
                (clicked)="onVoicemailButtonClicked(true)"
              ></ziro-button>
            }
            @if (!showVoicemailCard || cannotReassign) {
              <ziro-button
                [isPending]="isSubmitting"
                [dataAutomation]="'reassign-button'"
                [iconPending]="ziroIcons.SAVING"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                [label]="'tkey;operations.menu.reassign.text'"
                [isDisabled]="isSubmitting || cannotReassign"
                [ngbTooltip]="
                  cannotReassign
                    ? ('tkey;transfer.publicToUser.cannot_reassign.tooltip' | translate: { displayName })
                    : ''
                "
                (clicked)="onReassignClicked()"
              ></ziro-button>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
